import React from "react";
import PropTypes from "prop-types";
import Dialog from "./Dialog";
import ImageCompression from "../forms/ImageCompression";

const ImageCompressionDialog = (props) => {
  const handleChange = (name, file) => {
    let files = [...props.files];
    const fileIndex = parseInt(name.replace("image", ""));
    const fileInfo = {
      ...files[fileIndex],
      name: file.name,
      extension: "." + file.name.split(".")[1],
      size: file.size,
      getRawFile: () => {
        return file;
      },
    };
    files[fileIndex] = fileInfo;
    props.onChange(files);
  };

  const handleConfirm = (name) => {
    let files = [...props.files];
    const fileIndex = parseInt(name.replace("image", ""));
    files[fileIndex].l_resize = false;
    props.onChange(files);
  };

  const files = props.files;
  return (
    <Dialog
      isOpen={props.isOpen}
      onClose={props.onClose}
      onConfirm={props.onConfirm}
      title={"Úprava veľkosti obrázkov"}
      fullscreen={true}
    >
      <div>
        {files.map(
          (file, fileIndex) =>
            file.l_resize && (
              <ImageCompression
                file={file.getRawFile()}
                imageTitle={file.name}
                onChange={handleChange}
                onConfirm={handleConfirm}
                name={"image" + fileIndex}
                key={"image" + fileIndex}
                requiredMaximumSize={props.requiredMaximumSize}
                required
              />
            )
        )}
      </div>
    </Dialog>
  );
};

ImageCompressionDialog.propTypes = {
  files: PropTypes.array,
  requiredMaximumSize: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default ImageCompressionDialog;
